import React, { useState, useEffect } from "react";
import styled from "styled-components";
import baseUrl from "config/baseUrl";
import Carousel from "react-multi-carousel";
import { useTranslation } from "react-i18next";
import "react-multi-carousel/lib/styles.css";

const axios = require("axios").default;

const BannerContentStyled = styled.div``;

const ListGroupItem = styled.a`
  // text-align: center;
  // padding: 10px;
`;

const StyledCarousel = styled(Carousel)`
  .react-multiple-carousel__arrow {
    background: none;
  }
`;

const ListGroupImg = styled.img`
  width: 100%;
`;

const BannerContent = (props) => {
  const [active, setActive] = useState(0);
  const [bannerDataList, setBannerDataList] = useState(null);
  const { t, i18n } = useTranslation();

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      // paritialVisibilityGutter: 50
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    var data = JSON.stringify({
      params: {
        bannerSettingId: "",
      },
      show: 100,
      page: 1,
      orderBy: "bannerSettingId",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/bannerlist`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        setBannerDataList(response.data);
        // setTotalPage(response.data.totalPage);
      })
      .catch((error) => {
        console.log(error);
      });
  }, {});
  const onNext = () => {
    if (active >= bannerDataList.data.length - 1) setActive(0);
    else setActive(active + 1);
  };

  const onPrev = () => {
    if (active === 0) setActive(bannerDataList.data.length - 1);
    else setActive(active - 1);
    // if ( current === 0 ) return
    // else setCurrent(current - 1)
  };
  // const carouselEl = document.querySelector('#carousel')
  // const carousel = new bootstrap.Carousel(carouselEl, {
  //   interval: 2000,
  //   wrap: false
  // })
  return (
    // <Row>
    //   <Col sm={{ size: 4, order: 4, offset: 4 }}>
    //     <InputGroup>
    //       <FormInput placeholder="ค้นหาข้อมูล/ตัวชี้วัด" />
    //       <InputGroupAddon type="append">
    //         <Button className="btn-success">ค้นหา</Button>
    //       </InputGroupAddon>
    //     </InputGroup>
    //   </Col>
    // </Row>
    <BannerContentStyled>
      {/* <div
        id="carouselExampleIndicators"
        class="carousel slide"
        data-ride="carousel"
      >
        <ol class="carousel-indicators">
          {bannerDataList !== null &&  bannerDataList.data.length > 0 &&
            bannerDataList.data.map((item, key) => (
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to={key}
                className={active === key ? "active" : ""}
                onClick={() => setActive(key)}
              ></li>
            ))}
        </ol>
        <div class="carousel-inner">
        {bannerDataList !== null &&  bannerDataList.data.length > 0 &&
            bannerDataList.data.map((item, key) => (
              <div className={`carousel-item ${active === key ? "active" : ""}`}  data-interval="2000">
                <a  href={`https://${item.bannerSettingLink}`} target="_blank">
                <img class="d-block w-100" src={`${baseUrl}/${item.bannerSettingPic}`} alt="banner" />
                </a>
              </div>
            ))}
        </div>
        <a
          class="carousel-control-prev"
          onClick={onPrev}
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
         onClick={onNext}
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div> */}

      <StyledCarousel
        additionalTransfrom={0}
        arrows
        autoPlay={true}
        autoPlaySpeed={4000}
        centerMode={false}
        className="carousel-agency-container"
        containerClass="container-with-dots"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        renderButtonGroupOutside={false}
        renderDotsOutside={false}
        responsive={responsive}
        showDots={false}
        sliderClass=""
        slidesToSlide={1}
      >
        {bannerDataList !== null &&
          bannerDataList.data.length > 0 &&
          bannerDataList.data.map((item, key) => (
            <ListGroupItem
              key={key}
              href={`${item.bannerSettingLink}`}
              target="_blank"
            >
              <ListGroupImg
                src={`${baseUrl}/${
                  i18n.language === "th"
                    ? item.bannerSettingPic
                    : item.bannerSettingENPic
                }`}
              />
            </ListGroupItem>
          ))}
      </StyledCarousel>
    </BannerContentStyled>
  );
};
export default BannerContent;
